import React from 'react';

const Manaje = () => {
    return (
        <div>
            <h3>manaje inventory under developer....</h3>
        </div>
    );
};

export default Manaje;
